import { createSelector } from 'reselect'
import { NAME } from './constants'

export const getProfile = createSelector(
  (state) => state[NAME].profile,
  (profile) => profile
)

export default { getProfile }
